import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { handleShowPassword } from "../../../utils";
import { OnPasswordReset } from "./queries";
import Button from "../../../components/common/Button";
import Form from "../../../components/common/Form";
import Input from "../../../components/common/Input";
import LeftBase from "../../../components/common/LeftBase";
import active_eye from "../../../svg/active-eye.svg";
import eye_closed from "../../../svg/eye-closed.svg";
import active_lock from "../../../svg/active-lock.svg";
import disable_eye from "../../../svg/disable-eye.svg";
import disable_lock from "../../../svg/disable-lock.svg";
import loginFooter from "../../../assets/assets_html/images/login-footer-icon.png";
import SuccessModal from "../../../components/Modal/sucessModal";
import Logo from "../../../components/logo/Logo";
import { Helmet } from "react-helmet";
import "./index.scss";

function ResetPassword() {
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });

  const [disabled, setDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();

  const sucessHandler = (resetSucess) => {
    setShowModal(true);
  };

  const handleModalSubmit = (e) => {
    e.preventDefault();
    setShowModal(false);
    navigate("/login");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/login");
  };

  const { mutate: resetPassword } = OnPasswordReset(sucessHandler);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passwords.newPassword !== passwords.confirmPassword) {
      setErrorMsg("Passwords do not match");
      return;
    }
    setErrorMsg("");
    const queryParams = {
      header: { token: token },
      passwords,
    };
    resetPassword(queryParams);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...passwords, [name]: value };
    setPasswords(updated);

    if (name === "confirmPassword" && updated.newPassword && value) {
      if (updated.newPassword !== value) {
        setErrorMsg("Passwords do not match");
      } else {
        setErrorMsg("");
      }
    } else if (name === "newPassword" && updated.confirmPassword && value) {
      if (value !== updated.confirmPassword) {
        setErrorMsg("Passwords do not match");
      } else {
        setErrorMsg("");
      }
    } else {
      setErrorMsg("");
    }
  };

  useEffect(() => {
    const hasBoth = passwords?.newPassword && passwords?.confirmPassword;
    const match = passwords?.newPassword === passwords?.confirmPassword;
    setDisabled(!hasBoth || !match);
  }, [passwords]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="container-flex reset-password-page">
        <div className="row h-100">
          <div className="col-lg-5 col-xl-5 d-none d-lg-block left-base position-relative">
            <LeftBase type="Login" backToHomeBtn={false} />
          </div>
          <div className="col-lg-7 col-xl-7 col-md-12 col-sm-12 m-auto reset-password-form-column">
            <div className="p-3 w-100">
              <div className="login-form-container">
                <div className="login-header text-start">
                  <div className="reset-logo-wrapper mb-4">
                    <Logo />
                  </div>
                  <h1 className="login-title">Reset Password</h1>
                  <p className="login-subtitle" style={{ color: "#000000" }}>
                    Remember your password?{" "}
                    <Link to="/login" className="register-link">
                      LOGIN HERE
                    </Link>
                  </p>
                </div>

                <Form onSubmit={handleSubmit} className="mt-4">
                  <Input
                    name="newPassword"
                    handleChange={handleChange}
                    className={
                      passwords?.newPassword
                        ? "form-control active-input with_icon"
                        : "form-control grey-input with_icon"
                    }
                    type={!showPassword.newPassword ? "password" : "text"}
                    labelClass=""
                    preIconClass={
                      passwords?.newPassword ? active_lock : disable_lock
                    }
                    postIconClass={
                      passwords?.newPassword
                        ? showPassword.newPassword
                          ? eye_closed
                          : active_eye
                        : showPassword.newPassword
                          ? eye_closed
                          : disable_eye
                    }
                    value={passwords.newPassword}
                    label="New Password"
                    placeholder="*******************"
                    pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                    title="Password should have at least 8 characters, 1 uppercase letter, 1 number, and 1 special character"
                    onIconClick={() =>
                      handleShowPassword(
                        setShowPassword,
                        showPassword,
                        "newPassword"
                      )
                    }
                    mandatory={true}
                  />

                  <Input
                    name="confirmPassword"
                    handleChange={handleChange}
                    className={
                      passwords?.confirmPassword
                        ? "form-control active-input with_icon mt-2"
                        : "form-control grey-input with_icon mt-2"
                    }
                    type={!showPassword.confirmPassword ? "password" : "text"}
                    labelClass=""
                    preIconClass={
                      passwords?.confirmPassword ? active_lock : disable_lock
                    }
                    postIconClass={
                      passwords?.confirmPassword
                        ? showPassword.confirmPassword
                          ? eye_closed
                          : active_eye
                        : showPassword.confirmPassword
                          ? eye_closed
                          : disable_eye
                    }
                    value={passwords.confirmPassword}
                    label="Re-enter New Password"
                    placeholder="*******************"
                    pattern="(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$"
                    title="Password should have at least 8 characters, 1 uppercase letter, 1 number, and 1 special character"
                    onIconClick={() =>
                      handleShowPassword(
                        setShowPassword,
                        showPassword,
                        "confirmPassword"
                      )
                    }
                    mandatory={true}
                  />

                  <div className="d-flex justify-content-between align-items-center mt-1 mb-2">
                    <div className="d-flex align-items-center gap-1">
                      <span
                        style={{
                          color: "#dc3545",
                          fontSize: "18px",
                          fontWeight: "700",
                        }}
                        className="mandatory-asterisk"
                      >
                        *
                      </span>
                      <p
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          marginBottom: "10px",
                          fontFamily: "Montserrat",
                        }}
                      >
                        Mandatory
                      </p>
                    </div>
                  </div>

                  {errorMsg && (
                    <div
                      className="text-danger mb-3"
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        fontFamily: "Montserrat",
                      }}
                    >
                      {errorMsg}
                    </div>
                  )}

                  <p
                    style={{
                      fontSize: "14px",
                      color: "#666666",
                      marginBottom: "20px",
                      lineHeight: "1.5",
                    }}
                  >
                    <i>
                      Password must be at least 8 characters long and contain at least one uppercase letter, one number, and one special character.
                    </i>
                  </p>

                  <div className="mt-4 text-center">
                    <Button
                      type="submit"
                      title="Reset Password"
                      disabled={disabled}
                    />
                  </div>

                  <div
                    style={{
                      position: "fixed",
                      bottom: "50px",
                      right: "50px",
                    }}
                    className="d-none d-md-block"
                  >
                    <img src={loginFooter} alt="login" />
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>

        <SuccessModal
          size="sm"
          modalHeading="Password Updated"
          upperInformationText="Your password has been changed successfully"
          lowerInformationText="Please login with your new password"
          show={showModal}
          closebutton={true}
          handleClose={handleCloseModal}
          submitButtonTitle={"Login"}
          LinkTitle="Home"
          LinkPath="/"
          onSubmit={handleModalSubmit}
        />
      </div>
    </>
  );
}

export default ResetPassword;
